import createRoutine from '@/utils/createRoutine'

export const dynamicFormListGetters = {
  DYNAMIC_FORM_LIST: 'DYNAMIC_FORM_LIST'
}

export const updateDynamicFormListRoutine = createRoutine('updateDynamicFormList')
export const checkDynamicFormListUpdatedRoutine = createRoutine('checkDynamicFormListUpdated')
